/** Korean messages. This table defines the message keys; every other locale must provide the same keys. */
export const ko = {
  // Shared
  "common.retry": "다시 시도",
  "common.otherRepo": "다른 레포",
  "common.close": "닫기",
  "common.closeEsc": "닫기 (Esc)",
  "common.signOut": "로그아웃",
  "common.open": "열기",
  "common.cancel": "취소",

  // Experiment status, warnings, seasons
  "status.running": "진행 중",
  "status.adopted": "채택",
  "status.rejected": "기각",
  "status.draft": "초안",
  "warning.no-yaml-block": "PR 본문에 YAML 블록이 없습니다.",
  "warning.yaml-parse-error": "YAML 블록을 해석할 수 없습니다. 형식을 확인해 주세요.",
  "warning.missing-hypothesis": "hypothesis(가설) 필드가 비어 있습니다.",
  "warning.invalid-status": "status 값이 running / adopted / rejected 중 하나가 아닙니다.",
  "warning.invalid-field": "일부 필드의 형식이 올바르지 않아 무시했습니다.",
  "warning.orphan": "부모 실험을 찾을 수 없어 research 아래에 표시했습니다.",
  "warning.cycle": "부모 관계가 순환해서 research 아래에 표시했습니다.",
  "warning.unknown-version": "parent에 적힌 research 버전 태그를 찾을 수 없어 research 아래에 표시했습니다.",
  "season.spring": "봄",
  "season.summer": "여름",
  "season.autumn": "가을",
  "season.winter": "겨울",

  // App shell and screens
  "app.loading": "불러오는 중…",
  "app.loadingRepo": "{repo} 불러오는 중…",
  "app.connectFailedTitle": "GitHub에 연결할 수 없습니다",
  "app.connectFailedBody": "네트워크 상태를 확인하고 다시 시도해 주세요.",
  "app.sessionExpired": "로그인이 만료되었습니다. 다시 로그인해 주세요.",
  "app.repoNotFound": "{repo} 레포를 찾을 수 없거나 접근 권한이 없습니다.",
  "app.treeFailedTitle": "트리를 불러오지 못했습니다",
  "app.invalidRepo": "owner/name 형식이 아닙니다.",
  "app.noRootTitle": "{root} 브랜치가 없습니다",
  "app.noRootBody": "ResearchTree는 {root} 브랜치를 연구 트리의 루트로 씁니다.",
  "app.noRootNext": "그다음 실험은 {prefix}<이름> 브랜치에서 PR로 기록합니다. 다른 이름을 쓰고 있다면 브랜치 설정을 바꿔 주세요.",
  "app.recheck": "다시 확인",
  "app.refreshFailed": "새로고침 실패: {error}",
  "app.refreshed": "최신 상태로 갱신했습니다.",
  "app.switchFailed": "화면 전환 실패: {error}",
  "app.noWebGL": "이 브라우저는 WebGL을 지원하지 않아 트리를 그릴 수 없습니다.",
  "app.repoInfo": "레포 정보",
  "app.detail": "실험 상세",
  "app.account": "계정",
  "hint.3d": "드래그 이동 · 오른쪽 드래그 회전 · 휠 확대 · 방향키로 노드 이동 · Esc 닫기",
  "hint.2d": "드래그 이동 · 휠 확대 · 방향키로 노드 이동 · Esc 닫기",
  "menu.openRepoOnGitHub": "이 레포 GitHub에서 열기",
  "menu.myIsland": "내 아일랜드 열기",
  "menu.openOtherRepo": "다른 레포 열기",
  "menu.guide": "사용 가이드",
  "menu.project": "ResearchTree 저장소",
  "toolbar.refresh": "새로고침",
  "toolbar.settings": "설정",
  "toolbar.fit": "전체 보기",
  "toolbar.flat": "평면 보기",
  "toolbar.tree": "트리 보기",
  "toolbar.raise": "입체 보기",
  "toolbar.island": "섬 보기",
  "toolbar.switchMode": "보기 전환: 섬 → 평면 → 트리 → 입체 트리",
  "brand.collapse": "카드 접기",
  "brand.expand": "카드 펼치기",
  "brand.layers": "상태 레이어",
  "brand.showStatus": "{status} 실험 보이기",
  "brand.dimStatus": "{status} 실험 흐리게",
  "brand.subVersions": "{root} {count}개 버전 · 총 {depth}세대",
  "brand.subBranches": "{root}에서 뻗은 가지 {count}개 · 총 {depth}세대",
  "brand.empty": "아직 {prefix}* PR이 없습니다.",
  "brand.emptyNext": "첫 실험 브랜치를 {root}에서 따서 PR을 열어 보세요.",
  "gens.nav": "세대 이동",
  "gens.label": "세대",
  "gens.prev": "이전 세대",
  "gens.next": "다음 세대",
  "gens.all": "전체 {n}",

  // Sign-in
  "login.intro": "실험 브랜치와 PR을 읽어 연구가 자라온 과정을 나무로 보여줍니다. 처음 한 번만 GitHub 로그인이 필요해요.",
  "login.withGitHub": "GitHub로 로그인",
  "login.deviceCodePrompt": "GitHub에서 아래 코드를 입력하고 승인해 주세요.",
  "login.openGitHub": "GitHub 열기",
  "login.deviceAuto": "승인하면 자동으로 넘어갑니다.",
  "login.tokenLabel": "개인 액세스 토큰",
  "login.withToken": "토큰으로 로그인",
  "login.tokenInvalid": "토큰을 확인할 수 없습니다. 권한과 만료일을 확인해 주세요.",
  "login.tokenHelp": "fine-grained 토큰이면 대상 레포에 Pull requests(읽기/쓰기), Contents(읽기) 권한을 주세요. 토큰은 이 브라우저에만 저장됩니다.",
  "login.patSummary": "개인 액세스 토큰(PAT)으로 로그인",

  // Repo picker
  "picker.title": "어떤 연구를 볼까요?",
  "picker.body": "research 브랜치와 experiment/* PR이 있는 레포를 골라 주세요.",
  "picker.repoLabel": "레포",
  "picker.loading": "레포 목록을 불러오는 중…",
  "picker.noMatch": "일치하는 레포가 없습니다.",
  "picker.private": "비공개",
  "picker.listFailed": "레포 목록을 불러오지 못했습니다. 직접 입력해 주세요.",
  "picker.formatError": "owner/name 형식으로 입력해 주세요.",
  "picker.recent": "최근에 본 레포",
  "picker.mine": "내 레포",
  "picker.demo": "데모 레포로 둘러보기",
  "picker.demoHint": "가상의 음성 합성 연구 1년치를 담은 예시 레포예요. 버전 5개, 나란히 비교한 가설들, 의도·스펙 문서를 볼 수 있어요.",

  // Settings
  "settings.title": "설정",
  "settings.language": "언어",
  "settings.languageAuto": "자동 ({source})",
  "settings.sourceBrowser": "브라우저 언어",
  "settings.sourceVscode": "VS Code 언어",
  "settings.languageNote": "언어는 모든 레포에 공통으로 적용됩니다.",
  "settings.branchTitle": "브랜치",
  "settings.branchBody": "루트 브랜치와 실험 브랜치 접두사는 레포의 .researchtree이 정합니다. 레포 하나에 설정 하나라서, 이 레포를 여는 사람은 모두 같은 트리를 봅니다.",
  "settings.save": "저장하고 다시 불러오기",

  // Detail panel
  "panel.path": "경로",
  "panel.versionEyebrow": "Research · 버전",
  "panel.version": "버전",
  "panel.tagged": "{date} 태그",
  "panel.mergedSection": "합쳐진 실험 · 이 버전을 만든 실험",
  "panel.noMerged": "이 버전에 연결된 채택 실험을 찾지 못했습니다.",
  "panel.versionMetrics": "이 버전의 메트릭",
  "panel.startedHere": "이 버전에서 시작한 실험",
  "panel.noStarted": "아직 이 버전에서 시작한 실험이 없습니다.",
  "panel.nextVersion": "다음 버전",
  "panel.viewOnGitHub": "GitHub에서 보기",
  "panel.started": "{date} 시작",
  "panel.merged": "{date} 머지",
  "panel.closed": "{date} 종료",
  "panel.tabSummary": "내용",
  "panel.tabMetrics": "메트릭",
  "panel.tabCollab": "협업",
  "panel.tabFiles": "변경사항",
  "panel.edit": "수정",
  "panel.editTitle": "실험 기록 수정",
  "panel.editHint": "YAML 블록에서는 위 필드만 바뀌고, 다른 필드와 주석, 필드 순서는 그대로 남습니다. 본문은 YAML 블록 아래 내용 전체예요.",
  "panel.fieldHypothesis": "가설",
  "panel.fieldChange": "변경",
  "panel.fieldStatus": "상태",
  "panel.statusAuto": "자동 (PR 상태를 따름)",
  "panel.fieldTags": "태그 (쉼표로 구분)",
  "panel.fieldWandb": "W&B 링크",
  "panel.fieldBody": "본문 (마크다운: 결론, 메모 등)",
  "panel.badUrl": "W&B 링크는 http:// 또는 https://로 시작해야 합니다.",
  "panel.save": "저장",
  "panel.saving": "저장 중…",
  "panel.saved": "PR 본문을 저장했습니다.",
  "panel.saveFailed": "저장하지 못했습니다: {error}",
  "panel.conflict": "그사이 GitHub에서 PR 본문이 바뀌었습니다. 새로고침한 뒤 다시 수정해 주세요.",
  "panel.commentsLoading": "댓글을 불러오는 중…",
  "panel.noComments": "아직 댓글이 없습니다.",
  "panel.commentsFailed": "댓글을 불러오지 못했습니다: {error}",
  "panel.commentPlaceholder": "댓글을 남겨 보세요 (마크다운)",
  "panel.commentSubmit": "댓글 남기기",
  "panel.commentPosting": "올리는 중…",
  "panel.commentFailed": "댓글을 올리지 못했습니다: {error}",
  "panel.reviewOn": "{path} 코드 리뷰",
  "panel.filesLoading": "변경사항을 불러오는 중…",
  "panel.noFiles": "바뀐 파일이 없습니다.",
  "panel.filesFailed": "변경사항을 불러오지 못했습니다: {error}",
  "panel.filesSummary": "파일 {n}개 · +{add} −{del}",
  "panel.noPatch": "미리보기가 없습니다 (바이너리이거나 변경이 너무 큽니다).",
  "panel.patchTruncated": "앞부분 {n}줄만 보여줍니다.",
  "panel.fileAdded": "추가",
  "panel.fileRemoved": "삭제",
  "panel.fileModified": "수정",
  "panel.fileRenamed": "이름 변경",
  "panel.viewFile": "GitHub에서 보기",
  "panel.tabCommits": "커밋",
  "panel.hypothesis": "가설",
  "panel.noHypothesis": "가설이 적혀 있지 않습니다.",
  "panel.change": "수정",
  "panel.record": "결과",
  "panel.openOnGitHub": "GitHub에서 열기",
  "panel.wandb": "학습 기록",
  "panel.checkout": "체크아웃",
  "panel.diff": "부모 대비 diff",
  "panel.children": "파생 실험",
  "panel.noChildren": "아직 이 실험에서 파생된 실험이 없습니다.",
  "panel.noMetrics": "기록된 메트릭이 없습니다. PR 본문 YAML의 metrics에 값을 적어 주세요.",
  "panel.metric": "지표",
  "panel.thisExperiment": "이 실험",
  "panel.parent": "부모",
  "panel.deltaVersion": "{parent}(마지막으로 합쳐진 실험 기준) 대비 변화입니다.",
  "panel.deltaParent": "부모 실험({parent}) 대비 변화입니다.",
  "panel.noParentMetrics": "research 첫 버전에서 시작한 실험이라 비교할 부모 메트릭이 없습니다.",
  "panel.commitsLoading": "커밋을 불러오는 중…",
  "panel.noCommits": "커밋이 없습니다.",
  "panel.commitsFailed": "커밋을 불러오지 못했습니다: {error}",

  // Tree view
  "tree.versionSub": "{date} · 합쳐진 실험 {n}개",
  "tree.rootSub": "연구의 뿌리",
  "panel.pathExpand": "경로 전체 보기",
  "panel.pathCollapse": "경로 접기",
  "panel.resize": "패널 너비 조절 (드래그, 방향키)",
  "panel.labelMetric": "라벨 메트릭",
  "panel.labelMetricHint": "이 섬의 실험 라벨에 표시할 메트릭입니다. 버전마다 따로 정합니다.",
  "panel.labelMetricNone": "표시 안 함",

  // Season gallery (guide)
  "gallery.title": "계절 갤러리",
  "gallery.sub": "계절마다 채택 · 진행 중 · 기각 · 초안 실험 하나씩. 나무 색은 가지 색, 계절은 꽃·반딧불·낙엽·눈 효과로, 땅 색은 시간축 위치의 계절을 따른다.",
  "gallery.closeUp": "계절별로 가까이 보기",
  "gallery.caption": "{season} · 채택 · 진행 중 · 기각 · 초안",
  "gallery.yearIsland": "한 해 전체: 3D 섬",
  "gallery.island": "3D 섬",
  "gallery.yearFlat": "한 해 전체: 평면 보기",
  "gallery.hypothesis": "{season}의 {state} 모습",

  // Hosts
  "web.stateMismatch": "로그인 요청이 일치하지 않습니다. 다시 시도해 주세요.",
  "web.proxyUnreachable": "인증 서버에 연결할 수 없습니다.",
  "web.noToken": "토큰을 받지 못했습니다.",
  "web.noClientId": "OAuth App client ID가 설정되지 않았습니다 (VITE_GITHUB_CLIENT_ID).",
  "web.noClientIdShort": "OAuth App client ID가 설정되지 않았습니다.",

  // 연구 소개 암초 (research v1 옆)
  "intro.reef": "연구 소개",
  "intro.reefSub": "이 연구가 무엇인지",
  "intro.title": "연구 소개",
  "intro.overview": "연구 개요",
  "intro.project": "프로젝트 목표",
  "intro.research": "연구 목표",
  "intro.intent": "의도",
  "intro.spec": "스펙",
  "intro.empty": "읽을 문서가 없어요. 루트 브랜치에 README.md를 두면 여기에 보여요.",
  "intro.loading": "문서를 읽는 중…",
  "intro.failed": "문서를 읽지 못했어요: {error}",
  "intro.source": "{ref}의 {path}",

  // 아일랜드 (docs/ISLAND.md): 계정의 연구 전체를 한 지도로
  "world.title": "{user}의 연구",
  "world.researchCount": "연구 {count}개",
  "world.portal": "{name}로 건너가기",
  "world.portalSub": "포탈",
  "world.back": "지도로 돌아가기",
  "world.map": "지도",
  "world.mapTitle": "연구 지도",
  "world.mapHint": "누르면 그 섬으로 이동해요 · 두 번 누르면 그 연구를 열어요 · 연구 {count}개",
  "world.empty": "지도에 올린 연구가 없어요. `researchtree island add`로 올릴 수 있어요.",
  "world.noSettings": "{user} 님은 아직 ResearchIsland를 만들지 않았어요.",
  "world.noSettingsBody": "{user} 님에게 공유해서 ResearchIsland에 함께하자고 권해봐요!",
  "world.noSettingsHow": "계정에 .researchisland 레포를 만들고, README에 어떤 연구를 어디에 놓을지 적으면 이 지도가 만들어져요.",
  "world.share": "공유하기",
  "world.shareCopied": "초대 문구를 복사했어요",
  "world.shareFailed": "공유하지 못했어요",
  "share.inviteTitle": "ResearchTree — 연구가 자라는 섬",
  "share.inviteText":
    "{user} 님, ResearchTree에서 연구를 섬으로 남겨보세요. 브랜치 하나가 실험 하나, PR 하나가 실험 일지 하나예요. 쌓인 기록은 섬 위에서 나무로 자라요.\n시작하는 법: {guide}\n{user} 님의 섬이 열릴 자리:",
  "world.failed": "지도를 읽지 못했어요: {error}",
  "world.land": "아일랜드",
  "hint.world": "드래그 이동 · 휠 확대 · 섬을 누르면 그 연구로",
  "world.lockedName": "아직 열리지 않은 섬",
  "world.lockedSub": "권한이 있는 계정으로 로그인하면 열려요",
  "world.lockedTitle": "{repo}: 접근 권한이 필요해요",
  "world.locked": "{repo}는 열 수 없어요. 비공개 레포라면 접근 권한이 있는 계정으로 로그인해야 보여요.",

  // 연구자 소개와 이력서
  "profile.open": "연구자 소개",
  "profile.resume": "이력서 보기",
  "profile.title": "{user}",
  "profile.fromSettings": "PROFILE.md",
  "profile.fromAccount": "GitHub 프로필 소개",

  // 도착한 곳을 알리는 두루마리
  "banner.research": "연구",

  // 칸반 보기: PR이 실제로 거치는 단계
  "board.draft": "초안",
  "board.working": "작업 중",
  "board.review": "리뷰 중",
  "board.merged": "채택",
  "board.closed": "기각",
  "board.empty": "비어 있어요",
  "toolbar.board": "칸반 보기",
  "toolbar.boardOff": "섬으로 돌아가기",

  // 손님 모드 (로그인 없이 공개 레포 읽기)
  "guest.note": "로그인하지 않아 읽기 전용이에요.",
  "guest.noteDates": "실험이 언제 작업됐는지(커밋 날짜)는 로그인해야 보여요.",
  "guest.readOnly": "수정하려면 로그인",
  "guest.commentNeedsSignIn": "댓글을 쓰려면 로그인해 주세요.",
  "guest.signInTitle": "GitHub로 로그인하면 내 레포와 수정 기능을 쓸 수 있어요",
  "guest.rateLimited": "로그인 없이 볼 수 있는 횟수(시간당 60번)를 다 썼어요. 로그인하면 넉넉해져요.",
  "guest.needsSignIn": "{repo}를 열지 못했어요. 비공개 레포라면 로그인이 필요해요.",

  // PowerPoint 애드인
  "office.signingIn": "GitHub 로그인 중이에요…",
  "office.dialogFailed": "로그인 창을 열지 못했습니다.",
  "office.dialogClosed": "로그인 창이 닫혔습니다.",
  "office.saveView": "이 화면 저장",
  "office.saveViewTitle": "지금 보고 있는 화면을 이 슬라이드에 저장해요. 다음에 파일을 열면 이 화면으로 시작해요.",
  "office.viewSaved": "이 슬라이드에 저장했어요.",
  "office.saveFailed": "저장하지 못했어요. 슬라이드 쇼 중에는 저장할 수 없어요.",
  "office.demo": "데모 레포 둘러보기",
  "local.serverError": "로컬 서버 오류 ({status})",
  "local.userFailed": "로그인은 끝났지만 사용자 정보를 불러오지 못했습니다.",
  "local.codeExpired": "로그인 코드가 만료되었습니다. 다시 시도해 주세요.",
  "local.denied": "GitHub에서 로그인이 거부되었습니다.",
  "webview.timeout": "VS Code 확장 응답 시간 초과 ({type})",

  // Core
  "prbody.parseError": "PR 본문의 YAML 블록을 파싱할 수 없어 수정하지 않았습니다.",
  "prbody.notMap": "PR 본문의 YAML 블록이 key: value 형식이 아닙니다.",
  "github.invalidPath": "허용되지 않는 GitHub API 경로: {path}",

  // VS Code extension host
  "ext.openTooltip": "ResearchTree 열기",
  "ext.signedOut": "ResearchTree: 로그아웃했습니다.",
  "ext.signInCancelled": "GitHub 로그인이 취소되었습니다.",
  "ext.invalidToken": "GitHub 토큰이 유효하지 않습니다.",
  "ext.badRequest": "잘못된 GitHub 요청",
  "ext.badMethod": "허용되지 않는 메서드: {method}",
  "ext.httpOnly": "http(s) 주소만 열 수 있습니다.",
  "ext.badBranch": "잘못된 브랜치 이름",
  "ext.unknownRequest": "알 수 없는 요청: {type}",
  "ext.pickRepo": "ResearchTree로 볼 레포를 고르세요",
  "ext.noRepo": "워크스페이스에서 GitHub 레포를 찾지 못했습니다.",
  "ext.switching": "{branch}로 전환하는 중…",
  "ext.switched": "ResearchTree: {branch}로 전환했습니다.",
  "ext.checkoutFailed": "ResearchTree: 체크아웃 실패 ({branch}) — {error}",
  "ext.compareFailed": "ResearchTree: 변경 파일을 불러오지 못했습니다 (GitHub {status}).",
  "ext.noChanges": "ResearchTree: {base}와 {head} 사이에 바뀐 파일이 없습니다.",
  "ext.changedFiles": "{head} ← {base} 변경 파일 ({n}개)",
  "ext.openCompare": "ResearchTree: 로컬에서 브랜치를 찾지 못해 GitHub 비교 화면을 엽니다.",
  "panel.tabSpec": "스펙",
  "panel.tabOverview": "개요",
  "panel.claims": "검증하는 주장",
  "spec.loading": "스펙을 불러오는 중…",
  "spec.failed": "스펙을 불러오지 못했습니다: {error}",
  "spec.none": "이 버전에는 스펙 파일({path})이 없어요. 레포의 .researchtree에서 spec 경로를 바꿀 수 있어요.",
  "spec.modeFull": "전체",
  "spec.modeSummary": "요약",
  "spec.modeChanges": "변경",
  "spec.modes": "스펙 보기 방식",
  "spec.added": "추가",
  "spec.changed": "수정",
  "spec.renamed": "이름 변경",
  "spec.removed": "삭제",
  "spec.changedIn": "{version}에서 {kind}",
  "spec.preamble": "(머리말)",
  "spec.since": "{prev} 대비 바뀐 섹션 {n}개",
  "spec.noChanges": "{prev} 대비 바뀐 섹션이 없어요.",
  "spec.firstVersion": "첫 버전이라 비교할 이전 버전이 없어요. 모든 섹션이 이 버전에서 시작돼요.",
  "spec.mergedHere": "이 버전에 합쳐진 실험",
  "spec.history": "이력",
  "spec.historyTitle": "이 섹션의 이력",
  "spec.historyLoading": "모든 버전의 스펙을 읽는 중…",
  "spec.historyEmpty": "어느 버전에서도 바뀐 적이 없어요.",
  "spec.missing": "읽지 못한 include: {paths}",
  "spec.showDiff": "변경 내용 보기",
  "spec.expIntro": "이 브랜치가 갈라진 지점({sha}) 대비 스펙에서 바꾼 섹션이에요.",
  "spec.expAdopted": "채택된 실험이라 이 변경은 research에 들어갔어요.",
  "spec.expRejected": "기각된 실험이라 이 변경은 research에 들어가지 않았어요. 제안으로만 남아 있어요.",
  "spec.expRunning": "진행 중인 실험이에요. 채택되면 이 변경이 research에 들어가요.",
  "spec.expNone": "이 실험은 스펙을 바꾸지 않았어요.",
  "spec.expNoFile": "이 레포에는 스펙 파일({path})이 없어요.",
  "config.branches": "이 레포는 루트 {root}, 실험 {prefix}* 로 읽어요.",
  "config.defaults": "레포에 설정 파일이 없어서 기본값을 씁니다.",
  "config.repoWarnings": ".researchtree을 읽다가 무시한 항목: {items}",
} as const;

export type MessageKey = keyof typeof ko;
